<template>
  <section class="content-section">
      <h1>WIR FERTIGEN IHR PRODUKT NACH WUNSCH</h1>
      <div class="content-section-info" style="text-align:center">Naturstein im Innen- und Außenbereich erfreut sich einer immer stärkeren Beliebtheit, beispielsweise als Natursteinboden, Naturstein Küchenarbeitsplatte oder in Form von Granit Treppen, Marmor Fensterbänken und Quarzit Waschtischen. Bei allen Natursteinverarbeitungen ist es unser Bestreben Produkte in höchster Qualität zu fairen Preisen anzubieten. </div>
      <hr>
      <div class="container columns">
        <div class="info-box column medium" v-for="(leistung, index) in leistungen" :key="index">
            <h3>{{ leistung.title }}</h3>
            <div class="info-box-image">
                <router-link :to="leistung.link" class="info-box-link">Mehr erfahren</router-link>
                <img :src="leistung.image">
            </div>
            <article class="info-box-info">
                <div>{{ leistung.text  }}</div>
            </article>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: "LeistungUeberblick",
   metaInfo: {
    title: 'Wir fertigen Ihr Produkt nach Wunsch',
    meta:[
      { vmid: 'description', name: 'description', content: "Naturstein im Innen- und Außenbereich erfreut sich einer immer stärkeren Beliebtheit. Ob als Natursteinboden, Naturstein Küchenarbeitsplatte oder in Form von Granit Treppen."},
      { vmid: 'keywords', name: 'keywords', content: "Naturstein Küchenarbeitsplatten, Natursteinboden, Natursteintreppen, Naturstein Bad, Naturstein Tische, Naturstein Theken,Natursteintische Mönchengladbach"},
      
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/leistungen'} ]
  },
  data(){
      return{
            leistungen: [
                { 
                    title: "KÜCHENARBEITSPLATTEN",
                    image: "https://marmor-kunze.de/static/images/tile-image-01.jpg",
                    text: "Wir haben uns auf die maßgenaue Fertigung von einzigartigen Küchenarbeitsplatten aus Naturstein, Quarzkomposit und Keramik spezialisiert.",
                    link: "/leistungen/naturstein-kuechenarbeitsplatten"
                },
                { 
                    title: "BÖDEN",
                    image: "https://marmor-kunze.de/static/images/tile-image-02.jpg",
                    text: "Natursteinböden spielen in der modernen Innenraumgestaltung eine immer größere Rolle. Durch den Einsatz moderner Techniken können wir die Verwirklichung eines jeden Farb- und Strukturwunsches für Natursteinböden garantieren.",
                    link: "/leistungen/naturstein-boeden"
                },
                { 
                    title: "TREPPEN",
                    image: "https://marmor-kunze.de/static/images/tile-image-03.jpg",
                    text: "Natursteintreppen sind zeitlos, pflegeleicht und langlebig! Als Naturstein-Experte beraten und gestalten wir mit Ihnen zusammen Ihre individuelle Natursteintreppe, die sich harmonisch in ihre Wohnumgebung einpasst.",
                    link: "/leistungen/naturstein-treppen"
                },
                { 
                    title: "WASCHTISCHE & BÄDER",
                    image: "https://marmor-kunze.de/static/images/tile-image-04.jpg",
                    text: "Naturstein-Waschtische sind der Blickfang in Ihrem Badezimmer. Durch das individuelle Design und die vielfachen Gestaltungsmöglichkeiten des Natursteins entstehen bei uns handgefertigte Unikate, die ihrem Bad einen unverkennbaren Look geben.",
                    link: "/leistungen/naturstein-waschtische-und-baeder"
                },
                { 
                    title: "FENSTERBÄNKE",
                    image: "https://marmor-kunze.de/static/images/tile-image-05.jpg",
                    text: "Fensterbänke stehen meist nicht im Mittelpunkt, doch das Besondere einer Naturstein Fensterbank ist für jeden deutlich wahrnehmbar. Bei uns erhalten Sie hochwertige Naturstein Fensterbänke nach Maß, die wir genau nach Ihren Vorstellungen anfertigen und verlegen. ",
                    link: "/leistungen/naturstein-fensterbank"
                },
                 { 
                    title: "TISCHE UND THEKEN",
                    image: "https://marmor-kunze.de/static/images/tische_und_theken.jpg",
                    text: "Tische und Theken aus Naturstein sind zeitlose Klassiker. Ob Esstisch, Couchtisch, Beistelltisch, Terrassentisch oder Thekentisch, bei uns erhalten Sie ihr individuelles Naturstein Unikat.",
                    link: "/leistungen/naturstein-tische-und-theken"
                },
                { 
                    title: "EINGANGSBEREICHE",
                    image: "https://marmor-kunze.de/static/images/tile-image-08.jpg",
                    text: "Naturstein Treppenaufgänge und Podeste bieten neben allem Komfort auch einen tollen Blickfang und sorgen so für einen positiven ersten Eindruck bei Ihren Besuchern. In unserem Sortiment haben wir eine große Auswahl von Hartgesteinen, die im Außenbereich verwendet werden können.",
                    link: "/leistungen/naturstein-eingangsbereich"
                },
                { 
                    title: "INDIVIDUELLE PRODUKTE",
                    image: "https://marmor-kunze.de/static/portfolio/kamine/kamin01.jpg",
                    text: "Natürlich fertigen wir auch individuelle Produkte an! Von kleineren Anfertigen wie zum Beispiel Aschenbechern über Blumentöpfe oder Simse bis hin zu Kaminen ist alle möglich!",
                    link: "/leistungen/individuelle-naturstein-produkte"
                },
          ]
      }
  }
};
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/LeistungUeberblick.vue